import { render } from "./StrongAuthenticationRegister.vue?vue&type=template&id=51ad53fd&scoped=true&ts=true"
import script from "./StrongAuthenticationRegister.vue?vue&type=script&lang=ts"
export * from "./StrongAuthenticationRegister.vue?vue&type=script&lang=ts"

import "./StrongAuthenticationRegister.vue?vue&type=style&index=0&id=51ad53fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ad53fd"]])

export default __exports__